import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getExportOrder = (state: IRootState) => state.export.order;
export const getExportData = (state: IRootState) => state.export.data;
export const getExportPage = (state: IRootState) => state.export.page;
export const getExportTotalCount = (state: IRootState) => state.export.totalCount;
